exports = module.exports = require("../../../../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mt-50{margin-top:50px}", "", {"version":3,"sources":["W:/Web/GitHub/ct-adc-user-id-textarea/src/js/app/demo/component/App.vue"],"names":[],"mappings":"AACA,OACE,eAAiB,CAClB","file":"App.vue","sourcesContent":["\n.mt-50 {\n  margin-top: 50px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?{"minimize":true,"sourceMap":true}!./~/.11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-06977cf2","scoped":false,"hasInlineConfig":false}!./~/.6.0.6@sass-loader/lib/loader.js?{"sourceMap":true}!./~/.11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/js/app/demo/component/App.vue
// module id = 44
// module chunks = 0